import Raven from 'raven-js';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createSalesCopilotFirstMessageAndCreateThread, createSalesCopilotMessage } from '../api/hubGptApi';
import { formatHubGptApiMessages, formatHubGptApiMessage } from 'chatspot-core/messages/api/formatHubGptApiMessages';
export const sendSalesCopilotMessage = createAsyncThunk('chat/sendSalesCopilotMessage', async ({
  createThread,
  message,
  threadId
}) => {
  if (createThread) {
    const createThreadResponse = await createSalesCopilotFirstMessageAndCreateThread({
      message
    });
    const formattedMessage = formatHubGptApiMessages({
      messages: createThreadResponse.messages
    });
    return {
      message: formattedMessage,
      threadId: createThreadResponse.thread.id
    };
  }
  if (threadId) {
    const sendMessageResponse = await createSalesCopilotMessage({
      message,
      threadId
    });
    const formattedMessage = formatHubGptApiMessage({
      message: sendMessageResponse.message,
      threadId
    });
    return {
      message: formattedMessage,
      threadId
    };
  }
  Raven.captureException(new Error("Could not create thread or didn't recieve a threadId"));
  throw new Error("Could not create thread or didn't recieve a threadId");
});